import React, { useEffect } from 'react';
import { BsGithub } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FaReact, FaBootstrap } from 'react-icons/fa';
import { SiFirebase, SiReactrouter } from 'react-icons/si';


import img1 from '../../../images/project-details/quiz-mania/resized/1.png';
import img2 from '../../../images/project-details/quiz-mania/resized/2.png';
import img3 from '../../../images/project-details/quiz-mania/resized/3.png';
import img4 from '../../../images/project-details/quiz-mania/resized/4.png';
import img5 from '../../../images/project-details/quiz-mania/resized/5.png';
import img6 from '../../../images/project-details/quiz-mania/resized/6.png';
import quiz from '../../../images/project-details/quiz-mania/quiz.gif';


import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';



import QuizMania1Large from '../../../images/projects-large-image/QuizMania1.png';
import QuizMania2Large from '../../../images/projects-large-image/QuizMania2.png';
import useTitle from '../../../Hooks/useTitle';






const QuizManiaDetails = () => {

    useTitle('Project | Quiz Mania')

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])




    // details er 1st pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const divStyle1 = {
        backgroundImage: ` url(${QuizMania1Large})`,
        transition: 'ease 5s'
    };
    const handleHover1 = () => {
        divStyle1.transition = 'ease 5s'
    };
    const handleUnHover1 = () => {
        divStyle1.transition = 'ease 1s'
    };



    // details er 2nd pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const divStyle2 = {
        backgroundImage: ` url(${QuizMania2Large})`,
        transition: 'ease 5s'
    };
    const handleHover2 = () => {
        divStyle2.transition = 'ease 5s'
    };
    const handleUnHover2 = () => {
        divStyle2.transition = 'ease 1s'
    };







    return (
        <div>
            <div>

                {/* <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-4xl lg:text-4xl animation' data-aos='flip-right'>Quiz <span className='text-rose-600 text-6xl'>Mania</span></h1> */}

                <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse lg:mb-0 md:mb-0 sm:mb-8 mb-8 mt-16'>
                    <h1 className='uppercase text-center text-2xl sm:text-2xl md:text-3xl lg:text-3xl  animation lg:mt-0 md:mt-0 sm:-mt-10 -mt-10' data-aos='flip-right'>Quiz <span className='text-rose-600 text-5xl'>Mania</span></h1>
                    <div className='ml-4'>
                        <div className="avatar lg:-mt-2 md:-mt-8 sm:mt-2 mt-2 lg:mb-0 md:mb-0 sm:mb-12 mb-12 ">
                            <div className="w-24 sm:w-24 md:w-28 lg:w-28 rounded-xl">
                                <img src={quiz} alt='bike' className='' />
                            </div>
                        </div>
                    </div>
                </div>


                <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-10  gap-y-8 mt-8 mb-24 animation' data-aos='flip-left'>

                    <div className='lg:w-[460px] md:w-[335px] sm:w-[355px] w-[355px]  mx-auto' >
                        <div
                            style={divStyle1}
                            onMouseEnter={handleHover1}
                            onMouseLeave={handleUnHover1}
                            className=" bg-top bg-cover  hover:bg-bottom rounded-lg  lg:w-[460px] lg:h-[308px] md:w-[330px] md:h-[220px] sm:w-[338px] sm:h-[220px] w-[338px] h-[220px] mx-auto"></div>
                    </div>


                    <div className='lg:w-[460px] md:w-[335px] sm:w-[355px] w-[355px]  mx-auto' >
                        <div
                            style={divStyle2}
                            onMouseEnter={handleHover2}
                            onMouseLeave={handleUnHover2}
                            className=" bg-top bg-cover  hover:bg-bottom rounded-lg  lg:w-[460px] lg:h-[308px] md:w-[330px] md:h-[220px] sm:w-[338px] sm:h-[220px] w-[338px] h-[220px] mx-auto"></div>
                    </div>



                    <div className="card mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 ">
                        <img className='rounded-lg ' src={img2} alt="car!" />
                    </div>

                    <div className="card mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img3} alt="car!" />

                    </div>

                    <div className="card mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img4} alt="car!" />

                    </div>

                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">

                        <img className='rounded-lg ' src={img5} alt="car!" />

                    </div>


                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 group">
                        <img className='rounded-lg relative' src={img6} alt="car!" />
                        <h1 className='text-teal-600 font-bold text-4xl text-center absolute top-28 left-28 invisible  group-hover:visible group-hover:scale-110 group-hover:duration-300 group-hover:animate-bounce'>Teacher Details</h1>
                    </div>

                </div>





                <div>
                    <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                    </h1>

                    <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                        <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">

                            <h1 className='text-justify text-lg' > ⚪ Short Quiz Mania is a quiz project that helps the students to take part in quizzes of different subjects. For the sake of this project I have added 4 subjects for quizzes for the time being. But it will be updated very soon.</h1> <br></br>

                            <h1 className='text-justify text-lg '> ⚪ This website is made by using React Router DOM. and for styling I have used bootstrap and some custom css. By click the nav links the website redirects to the respected url. All the data are fetched from API ans display on UI. For the right and wrong answers we have added React Toastify for better user experience. </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ The project shows different quiz subjects with some of the question for each subject. If any student clicks on a answer then a toaster will appear and display whether the answer is right or wrong.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ By clicking on the eye icon that is located on the right side of each question one can see the correct answer easily. </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪  Besides the project contains the statistics chart that shows the number of question respected to the subject name. If someone clicks on the blog section then the url redirects him/her to some of the frequently asked questions that we got.
                            </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ the website also shows the active route with a different color on the nav bar. so that user can understand which route he/she is visiting. If someone wants to visit a route which is not assigned then an error message will be shown.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ By clicking on the about link the user we find the courses that we provide. They can also find the course instructors details.
                            </h1>

                        </div>


                        <div className='w-full sm:w-full md:w-full lg:w-2/4'>

                            <h2 className='text-center text-3xl mt-4 mb-12'>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                            <div className=''>

                                {/* <a href='https://bright-dieffenbachia-546722.netlify.app/topics' target='blank' title='Live Site Demo'>

                                    <div className='bg-black border-2 border-teal-400  flex justify-center items-center rounded-lg px-8 gap-x-2 sm:mb-4 md:mb-0 lg:mb-0 mb-4 lg:w-full md:w-full sm:w-full w-full  hover:border-green-600  transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 lg:mb-8 md:mb-8 sm:mb-8 mb-8 animation' data-aos='fade-left'>

                                        <FaEye className='text-3xl mt-[3px] text-white'></FaEye>
                                        <button className='py-3 rounded-lg  text-white text-2xl  border-0 ' title='Visit Live Site'>Live Website</button>
                                    </div>
                                </a>

                                <a href='https://github.com/Fahimsakib1/short-quiz-mania' target='blank' title='GutHub Code'>
                                    <div className='bg-black border-2 border-teal-400  flex justify-center items-center rounded-lg px-8 gap-x-2 sm:mb-4 md:mb-0 lg:mb-0 mb-4 lg:w-full md:w-full sm:w-full w-full hover:border-green-600  transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300  animation' data-aos='fade-right'>

                                        <BsGithub className='text-3xl text-white'></BsGithub>
                                        <button className='py-3 rounded-lg  text-white text-2xl  border-0 ' title='Client  Side Source Code'>GitHub Code</button>
                                    </div>
                                </a> */}


                                <a href='https://bright-dieffenbachia-546722.netlify.app/topics' target='blank' title='Live Site Demo'>
                                    <div className='relative group mt-4 animation' data-aos='fade-left'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>Live Website</span>
                                                <FaEye className='text-3xl text-white'></FaEye>
                                            </div>
                                        </button>
                                    </div>

                                </a>

                                <a href='https://github.com/Fahimsakib1/short-quiz-mania' target='blank' title='GutHub Code'>
                                    <div className='relative group mt-4 animation' data-aos='fade-right'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-blue-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>GitHub Code</span>
                                                <BsGithub className='text-3xl text-white'></BsGithub>
                                            </div>
                                        </button>
                                    </div>
                                </a>



                            </div>

                            <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                            <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                                <div className='border-2 border-violet-600 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaReact className='text-4xl mx-2 text-cyan-500'></FaReact>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React JS</h1>
                                </div>

                                <div className='border-2 border-violet-600 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <SiFirebase className='text-4xl mx-2 text-yellow-400'></SiFirebase>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Firebase</h1>
                                </div>

                                <div className='border-2 border-violet-600 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <SiReactrouter className='text-4xl mx-2 text-red-600'></SiReactrouter>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React Router</h1>
                                </div>

                                <div className='border-2 border-violet-600 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaBootstrap className='text-4xl mx-2 text-blue-600'></FaBootstrap>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Bootstrap</h1>
                                </div>

                            </div>



                        </div>
                    </div>
                </div>





                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}




                <div className='mx-auto text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>





            </div>

        </div>
    );
};

export default QuizManiaDetails;